"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _environment = _interopRequireDefault(require("../../../../utils/environment"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var _getScriptDataConfig = function _getScriptDataConfig(data) {
  var stringifiedScriptDataConfig = '';
  if (data) {
    try {
      stringifiedScriptDataConfig = JSON.stringify(data);
    } catch (error) {
      // ignore error
    }
  }
  return stringifiedScriptDataConfig;
};
var _getScriptAttributes = function _getScriptAttributes(attributes) {
  var stringifiedScriptAttributes = [];
  var attributesObject = __assign({
    className: 'yp',
    type: 'text/javascript'
  }, attributes);
  Object.entries(attributesObject).forEach(function (_a) {
    var key = _a[0],
      value = _a[1];
    stringifiedScriptAttributes.push("".concat(key, "='").concat(value, "'"));
  });
  return stringifiedScriptAttributes.join(' ');
};
var initiateBySrc = function initiateBySrc(src, config) {
  if (_environment.default.isClient) {
    var scriptDataConfig = _getScriptDataConfig(config === null || config === void 0 ? void 0 : config.data);
    var scriptAttributes = _getScriptAttributes(config === null || config === void 0 ? void 0 : config.attributes);
    var script = "\n            <script\n                async\n                defer\n                ".concat(scriptAttributes, "\n                src='https://delivery.youplay.se/load.js?id=").concat(src, "'\n                data-config='").concat(scriptDataConfig || '{}', "'\n            />\n        ");
    var playerScript = document.createRange().createContextualFragment(script);
    return playerScript;
  }
};
var initiateByScript = function initiateByScript(config) {
  if (_environment.default.isClient) {
    var playerScript = document.createRange().createContextualFragment(config.script);
    return playerScript;
  }
};
var ShowHeros = {
  initiateBySrc: initiateBySrc,
  initiateByScript: initiateByScript
};
var _default = ShowHeros;
exports.default = _default;